import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-itinerario',
  templateUrl: './dialog-itinerario.component.html',
  styleUrls: ['./dialog-itinerario.component.scss']
})
export class DialogItinerarioComponent {
  public itens_humanas: any[] = [];
  public itens_natureza: any[] = [];

  public qtde_itens = signal<number>(0);

  constructor(
      public dialogRef: MatDialogRef<DialogItinerarioComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) { 

    this.itens_humanas = data.data.itens_grupo1;
    this.itens_natureza = data.data.itens_grupo2;
    this.qtde_itens.set(data.qtde);
    }
}
